import React from "react";
import CustomTooltip from "../../../../components/CustomTooltip";
import HighlightCardApp from "../Functionality/HighlightCardApp";
import EventMetaItem from "./EventMetaItem";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Large status card of the highlight panel: severity bar, pictogram, title and labeled details.
 *
 * @param {Object} event - Event received by the socket.
 * @param {number} now - Current timestamp, refreshes the elapsed time.
 */
const HighlightCard = ({ event, now }) => {
    const { severity, elapsed, metaItems, title, Icon } = HighlightCardApp({ event, now });

    return (
        <div className='event-monitoring-lazy-render d-flex border-full-shades-200 border-radius-8px background-shades-50'>
            <div className={`flex-shrink-0 w-8px border-radius-8px-0px ${severity.BORDER_CLASS} ${severity.BACKGROUND_CLASS}`} />
            <div className='d-flex flex-grow-1 gap-12px p-3 minw-0'>
                <div className={`event-monitoring-severity-pictogram w-36px h-36px border-radius-4px ${severity.BACKGROUND_CLASS}`}>
                    <Icon className={`btn-icon-svg-20px ${severity.ICON_CLASS}`} />
                </div>
                <div className='d-flex flex-column flex-grow-1 gap-3 minw-0'>
                    <div className='d-flex flex-column gap-2 minw-0'>
                        <div className='d-flex align-items-center justify-content-between gap-12px'>
                            {/* The title shrinks and is cut with an ellipsis, so it never covers the elapsed time */}
                            <div className='minw-0'>
                                <CustomTooltip
                                    text={title}
                                    classes='d-block fs-14px ibl-font-w-600 font-color-general-950 text-capitalize text-truncate'
                                    showIfTruncated
                                    placement='top'
                                />
                            </div>
                            <p className='flex-shrink-0 fs-14px font-color-shades-500 text-nowrap'>{elapsed}</p>
                        </div>
                        <CustomTooltip
                            text={event.description}
                            classes='fs-14px ibl-font-w-400 font-color-shades-950 text-ellipsis-1-row'
                            showIfTruncated
                            placement='top'
                        />
                    </div>
                    <div className='d-flex flex-column gap-2'>
                        {metaItems.map((item, index) => (
                            <EventMetaItem key={index} Icon={item.Icon} label={item.label} value={item.value} showLabel />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

// Memo so a new event at the top of the panel does not render every card again //
export default React.memo(HighlightCard);
